/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'
export type Amount = {
	value: number
	precision: number
}
export type TaxAmount = {
	gross: Amount
	tax: Amount
	net: Amount
}
export type AppUpdateBranch = {
	name: string
	isPr: boolean
	latestUpdateAt: number | null
	updateCount: number
}
export type AppUpdate = {
	id: string
	branchName: string
	createdAt: number
	message: string | null
	runtimeVersion: string
	gitCommitHash: string | null
	fingerprint: string | null
}
export const PaymentProvider = {
	AdyenTerminal: 'ADYEN_TERMINAL',
	AdyenEcom: 'ADYEN_ECOM',
	BlikkEcom: 'BLIKK_ECOM',
	BlikkPos: 'BLIKK_POS',
	Cash: 'CASH',
	BusinessCard: 'BUSINESS_CARD',
	GiftCard: 'GIFT_CARD',
	LoyaltyPoints: 'LOYALTY_POINTS',
	VippsMobilepay: 'VIPPS_MOBILEPAY',
	NetsTerminal: 'NETS_TERMINAL',
	VerifoneCheckout: 'VERIFONE_CHECKOUT',
	VerifoneEcom: 'VERIFONE_ECOM',
	StraumurEcom: 'STRAUMUR_ECOM',
	RapydCloudlink: 'RAPYD_CLOUDLINK',
	TeyaPoslink: 'TEYA_POSLINK',
	VerifonePosCloud: 'VERIFONE_POS_CLOUD'
} as const
export type PaymentProviderType = (typeof PaymentProvider)[keyof typeof PaymentProvider]
export const PaymentMethod = {
	SavedToken: 'SAVED_TOKEN',
	CashInstant: 'CASH_INSTANT',
	CashAsync: 'CASH_ASYNC',
	VerifoneEcomCard: 'VERIFONE_ECOM_CARD',
	VerifoneEcomToken: 'VERIFONE_ECOM_TOKEN',
	VerifoneEcomApplePay: 'VERIFONE_ECOM_APPLE_PAY',
	VerifoneEcomGooglePay: 'VERIFONE_ECOM_GOOGLE_PAY',
	VerifoneEcomCardCapture: 'VERIFONE_ECOM_CARD_CAPTURE',
	VerifoneCheckoutCard: 'VERIFONE_CHECKOUT_CARD',
	VerifoneCheckoutToken: 'VERIFONE_CHECKOUT_TOKEN',
	AdyenEcomCard: 'ADYEN_ECOM_CARD',
	AdyenTerminalApplePay: 'ADYEN_TERMINAL_APPLE_PAY',
	AdyenTerminalGooglePay: 'ADYEN_TERMINAL_GOOGLE_PAY'
} as const
export type PaymentMethodType = (typeof PaymentMethod)[keyof typeof PaymentMethod]
export const CardType = {
	Visa: 'VISA',
	Mastercard: 'MASTERCARD',
	Amex: 'AMEX',
	Discover: 'DISCOVER',
	Diners: 'DINERS',
	Jcb: 'JCB',
	Unionpay: 'UNIONPAY',
	Other: 'OTHER',
	BankAxept: 'BANK_AXEPT'
} as const
export type CardTypeType = (typeof CardType)[keyof typeof CardType]
export const OrderPaymentStatus = {
	Unpaid: 'UNPAID',
	Pending: 'PENDING',
	Paid: 'PAID',
	PartiallyPaid: 'PARTIALLY_PAID',
	Overpaid: 'OVERPAID',
	Refunded: 'REFUNDED',
	PartiallyRefunded: 'PARTIALLY_REFUNDED'
} as const
export type OrderPaymentStatusType = (typeof OrderPaymentStatus)[keyof typeof OrderPaymentStatus]
export const FulfillmentType = {
	DirectSale: 'DIRECT_SALE',
	Ecom: 'ECOM'
} as const
export type FulfillmentTypeType = (typeof FulfillmentType)[keyof typeof FulfillmentType]
export const FulfillmentStatus = {
	NotNeeded: 'NOT_NEEDED',
	NotFulfilled: 'NOT_FULFILLED',
	PartiallyFulfilled: 'PARTIALLY_FULFILLED',
	Fulfilled: 'FULFILLED'
} as const
export type FulfillmentStatusType = (typeof FulfillmentStatus)[keyof typeof FulfillmentStatus]
export const PricingMethod = {
	PerUnit: 'PER_UNIT',
	PerWeight: 'PER_WEIGHT',
	WeightEmbedded: 'WEIGHT_EMBEDDED',
	PriceEmbedded: 'PRICE_EMBEDDED'
} as const
export type PricingMethodType = (typeof PricingMethod)[keyof typeof PricingMethod]
export const OrderBagCheckStatus = {
	NotDetermined: 'NOT_DETERMINED',
	NotNeeded: 'NOT_NEEDED',
	Needed: 'NEEDED',
	Checked: 'CHECKED',
	Rejected: 'REJECTED'
} as const
export type OrderBagCheckStatusType = (typeof OrderBagCheckStatus)[keyof typeof OrderBagCheckStatus]
export type GenericSuccess = {
	success: true
}

export const zAmount = z.object({
	value: z.number(),
	precision: z.number()
})
export const zTaxAmount = z.object({
	gross: zAmount,
	tax: zAmount,
	net: zAmount
})
export const zAppUpdateBranch = z.object({
	name: z.string(),
	isPr: z.boolean(),
	latestUpdateAt: z.number().nullable(),
	updateCount: z.number()
})
export const zAppUpdate = z.object({
	id: z.string(),
	branchName: z.string(),
	createdAt: z.number(),
	message: z.string().nullable(),
	runtimeVersion: z.string(),
	gitCommitHash: z.string().nullable(),
	fingerprint: z.string().nullable()
})
export const zPaymentProvider = z.enum([
	'ADYEN_TERMINAL',
	'ADYEN_ECOM',
	'BLIKK_ECOM',
	'BLIKK_POS',
	'CASH',
	'BUSINESS_CARD',
	'GIFT_CARD',
	'LOYALTY_POINTS',
	'VIPPS_MOBILEPAY',
	'NETS_TERMINAL',
	'VERIFONE_CHECKOUT',
	'VERIFONE_ECOM',
	'STRAUMUR_ECOM',
	'RAPYD_CLOUDLINK',
	'TEYA_POSLINK',
	'VERIFONE_POS_CLOUD'
])
export const zPaymentMethod = z.enum([
	'SAVED_TOKEN',
	'CASH_INSTANT',
	'CASH_ASYNC',
	'VERIFONE_ECOM_CARD',
	'VERIFONE_ECOM_TOKEN',
	'VERIFONE_ECOM_APPLE_PAY',
	'VERIFONE_ECOM_GOOGLE_PAY',
	'VERIFONE_ECOM_CARD_CAPTURE',
	'VERIFONE_CHECKOUT_CARD',
	'VERIFONE_CHECKOUT_TOKEN',
	'ADYEN_ECOM_CARD',
	'ADYEN_TERMINAL_APPLE_PAY',
	'ADYEN_TERMINAL_GOOGLE_PAY'
])
export const zCardType = z.enum([
	'VISA',
	'MASTERCARD',
	'AMEX',
	'DISCOVER',
	'DINERS',
	'JCB',
	'UNIONPAY',
	'OTHER',
	'BANK_AXEPT'
])
export const zOrderPaymentStatus = z.enum([
	'UNPAID',
	'PENDING',
	'PAID',
	'PARTIALLY_PAID',
	'OVERPAID',
	'REFUNDED',
	'PARTIALLY_REFUNDED'
])
export const zFulfillmentType = z.enum(['DIRECT_SALE', 'ECOM'])
export const zFulfillmentStatus = z.enum(['NOT_NEEDED', 'NOT_FULFILLED', 'PARTIALLY_FULFILLED', 'FULFILLED'])
export const zPricingMethod = z.enum(['PER_UNIT', 'PER_WEIGHT', 'WEIGHT_EMBEDDED', 'PRICE_EMBEDDED'])
export const zOrderBagCheckStatus = z.enum(['NOT_DETERMINED', 'NOT_NEEDED', 'NEEDED', 'CHECKED', 'REJECTED'])
export const zGenericSuccess = z.object({
	success: z.literal(true)
})
